import React from 'react';
import { useNavigate } from 'react-router-dom';

type VerticalKey = 'it_support' | 'dental' | 'consultancy' | 'saas' | 'restaurant';

const VERTICALS: Array<{
  key: VerticalKey;
  name: string;
  blurb: string;
  recommendedTemplate?: 'modern' | 'minimal' | 'elegant' | 'bold';
}> = [
  {
    key: 'it_support',
    name: 'IT Support',
    blurb: 'Professional IT services: SLAs, Microsoft 365, security & compliance, proactive monitoring.',
    recommendedTemplate: 'modern',
  },
  {
    key: 'dental',
    name: 'Dental Clinic',
    blurb: 'Procedures, insurance, booking CTA, team profiles, location and hours with testimonials.',
    recommendedTemplate: 'elegant',
  },
  {
    key: 'consultancy',
    name: 'Consultancy',
    blurb: 'Practice areas, case studies, credentials, measurable results and strong calls to action.',
    recommendedTemplate: 'minimal',
  },
  {
    key: 'saas',
    name: 'SaaS Product',
    blurb: 'Product features, integrations, pricing, security/compliance and FAQs.',
    recommendedTemplate: 'bold',
  },
  {
    key: 'restaurant',
    name: 'Restaurant',
    blurb: 'Menu highlights, hours & location, reservation CTA, photo gallery and reviews.',
    recommendedTemplate: 'elegant',
  },
];

const TemplateLibrary: React.FC = () => {
  const navigate = useNavigate();

  const selectTemplate = (vertical: VerticalKey, template?: 'modern' | 'minimal' | 'elegant' | 'bold') => {
    const params = new URLSearchParams();
    params.set('vertical', vertical);
    if (template) params.set('template', template);
    navigate(`/marketing/ai-website-generator?${params.toString()}`);
  };

  return (
    <div className="max-w-5xl mx-auto px-4 py-10">
      <h1 className="text-3xl font-bold text-gray-900 mb-2">Template Library</h1>
      <p className="text-gray-600 mb-6">Choose a business type to start from a tailored template. You can change the visual style later.</p>
      <div className="grid gap-6 md:grid-cols-2">
        {VERTICALS.map(v => (
          <div key={v.key} className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 flex flex-col">
            <div className="flex-1">
              <h2 className="text-xl font-semibold text-gray-900">{v.name}</h2>
              <p className="text-gray-600 mt-2 text-sm">{v.blurb}</p>
            </div>
            <div className="mt-4">
              <button
                type="button"
                className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700"
                onClick={() => selectTemplate(v.key, v.recommendedTemplate)}
              >
                Use this template
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TemplateLibrary;
